// The project page's right panel can be closed (Pendampingan, Chat di
// project ini, File project): an X in the panel's own head closes it, a
// toggle in the page's header (beside the moreH Menu) closes and reopens it.
// One choice per browser for every project (lib/prefs SIDE_PANEL_KEY); the
// page carries it as data-panel on .pj, and CSS gives the main column the
// freed width. Folder projects, paket projects and conversations alike.
import { SIDE_PANEL_KEY, useFlag } from "../lib/prefs";
import { Glyph } from "../ui/icons";

/** The panel's id, for aria-controls (one panel per page). */
export const PANEL_ID = "pj-aside";

export function useSidePanel(): [boolean, (open: boolean) => void, () => void] {
  return useFlag(SIDE_PANEL_KEY, true);
}

/** The header toggle: Tutup panel / Buka panel. */
export function PanelToggle({ className = "" }: { className?: string }) {
  const [open, , toggle] = useSidePanel();
  const label = open ? "Tutup panel project" : "Buka panel project";
  return (
    <button type="button" className={`ui-icon-btn pj-panel-toggle ${className}`.trim()} aria-expanded={open} aria-controls={PANEL_ID} aria-label={label} title={label} onClick={toggle}>
      <Glyph name="sidebarLeft" />
    </button>
  );
}

/** The panel's own head: its name and the close button. */
export function PanelHead() {
  const [, setOpen] = useSidePanel();
  return (
    <div className="pj-aside-head">
      <span className="pj-aside-name">Panel project</span>
      <button type="button" className="ui-icon-btn pj-panel-close" aria-controls={PANEL_ID} aria-expanded="true" aria-label="Tutup panel project" title="Tutup panel project" onClick={() => setOpen(false)}>
        <Glyph name="close" />
      </button>
    </div>
  );
}
